export const BLOCK_TYPE_BANNER = 'banner';
